/**
 * Time-range button group used in RankTab to slice the visibility chart + baseline
 * comparison column. Lifted out so the host can stay focused on data fetching.
 */
import React from "react";

export const RANGE_OPTIONS = [
  { v: "30d", label: "30 days", days: 30 },
  { v: "3m", label: "3 months", days: 92 },
  { v: "6m", label: "6 months", days: 183 },
  { v: "12m", label: "12 months", days: 366 },
  { v: "all", label: "All time" },
];

export default function RangeSelector({ value, onChange, baselineLabel, snapshotCount }) {
  return (
    <div className="card-soft p-3 flex items-center justify-between flex-wrap gap-3" data-testid="rank-range-selector">
      <div className="text-[11px] uppercase tracking-widest text-[#a0aec0] font-semibold px-2">
        Compare rankings over
      </div>
      <div className="inline-flex items-center gap-1 p-1 bg-[#f7fafc] border border-[#edf2f7] rounded-xl">
        {RANGE_OPTIONS.map((o) => (
          <button
            key={o.v}
            onClick={() => onChange(o.v)}
            data-testid={`rank-range-${o.v}`}
            className={`text-[10px] uppercase tracking-widest font-bold px-2.5 py-1.5 rounded-lg transition-colors ${
              value === o.v
                ? "bg-white text-[#1a202c] shadow-sm border border-[#e2e8f0]"
                : "text-[#718096] hover:text-[#1a202c]"
            }`}
          >
            {o.label}
          </button>
        ))}
      </div>
      <div className="text-[10px] font-mono-tight text-[#a0aec0] uppercase tracking-widest px-2">
        {baselineLabel ? (
          <>
            baseline: <span className="text-[#1a202c] font-semibold">{baselineLabel}</span> · {snapshotCount} snapshot
            {snapshotCount === 1 ? "" : "s"}
          </>
        ) : (
          "no snapshots in range"
        )}
      </div>
    </div>
  );
}
